import { Injectable, Injector } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "@assoanalytics/app/shared/components/snackbar/snackbar.component";
import { TranslationHelperService } from "../language/translation-helper.service";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  private translationHelper: TranslationHelperService;

  constructor(private snackBar: MatSnackBar, private injector: Injector) {}

  error(
    message: string,
    action?: string,
    submessage?: string,
    duration?: number,
    shouldTranslate: boolean = false
  ) {
    // Per gli errori, impostiamo una durata più lunga se non specificata
    const errorDuration = duration || 8000; // 8 secondi per default per gli errori
    this.openSnackbar(
      "snackbar-error",
      "error",
      shouldTranslate
        ? this.getTranslatedText("ERROR_MODULE." + message)
        : message,
      shouldTranslate && action
        ? this.getTranslatedText("ERROR_MODULE." + action)
        : action ?? "Ok",
      submessage,
      errorDuration
    );
  }

  warning(
    message: string,
    action?: string,
    duration?: number,
    shouldTranslate: boolean = false
  ) {
    // Per i warning, impostiamo una durata media se non specificata
    const warningDuration = duration || 5000; // 5 secondi per default per i warning
    this.openSnackbar(
      "snackbar-warning",
      "warning",
      shouldTranslate
        ? this.getTranslatedText("ERROR_MODULE." + message)
        : message,
      shouldTranslate && action
        ? this.getTranslatedText("ERROR_MODULE." + action)
        : action ?? "Ok",
      undefined,
      warningDuration
    );
  }

  success(message: string, action?: string, duration?: number): void {
    // Per i messaggi di successo, impostiamo una durata standard
    const successDuration = duration || 3000; // 3 secondi per default per i successi
    this.openSnackbar(
      "snackbar-success",
      "done",
      message,
      action,
      undefined,
      successDuration
    );
  }

  private openSnackbar(
    panelClass: string,
    icon: string,
    message: string,
    action?: string,
    submessage?: string,
    duration?: number
  ): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        icon: icon,
        message: message,
        action: action ?? "Ok",
        submessage: submessage ?? null,
      },
      panelClass: panelClass,
      duration,
    });
  }

  getTranslatedText(key: string): string {
    // Lazy resolve per evitare dipendenza circolare al costruttore
    if (!this.translationHelper) {
      this.translationHelper = this.injector.get(TranslationHelperService);
    }

    return this.translationHelper.instant(key);
  }
}
